module.exports = __webpack_public_path__ + "static/img/icon_zylx05.31420a25.png";